import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  size?: 'lg' | 'md' | 'xl';
  float?: boolean;
};
export const BookMockup: React.FC<Props> = ({
  size = 'lg',
  float = true
}) => {
  const dims = size === 'xl' ? {
    w: 'w-[300px] sm:w-[380px] md:w-[420px] lg:w-[440px]',
    h: 'h-[430px] sm:h-[540px] md:h-[600px] lg:h-[620px]'
  } : size === 'lg' ? {
    w: 'w-[280px] sm:w-[340px] md:w-[380px]',
    h: 'h-[400px] sm:h-[480px] md:h-[540px]'
  } : {
    w: 'w-[200px] sm:w-[240px]',
    h: 'h-[290px] sm:h-[340px]'
  };
  return <div className={`relative ${dims.w} ${dims.h}`} style={{
    perspective: '2000px'
  }} data-id="element-28">
      {/* Warm halo glow - large and warm */}
      <div className="absolute -inset-16 rounded-full opacity-70 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(229,200,150,0.35) 0%, rgba(212,175,122,0.2) 30%, transparent 65%)'
    }} data-id="element-29" />
      <div className="absolute -inset-8 rounded-full opacity-50 blur-2xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(212,175,122,0.4), transparent 60%)'
    }} data-id="element-30" />

      <motion.div animate={float ? {
      y: [0, -16, 0],
      rotateY: [-18, -16, -20, -18]
    } : {}} transition={{
      y: {
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut'
      },
      rotateY: {
        duration: 9,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} className="relative w-full h-full" style={{
      transformStyle: 'preserve-3d',
      transform: 'rotateY(-18deg) rotateX(2deg)'
    }} data-id="element-31">
        {/* Front cover */}
        <div className="absolute inset-0 book-cover-front rounded-r-[3px] rounded-l-[2px] overflow-hidden" style={{
        boxShadow: '0 40px 100px -20px rgba(0,0,0,0.8), 0 80px 140px -40px rgba(212,175,122,0.3), inset 0 0 0 1px rgba(212,175,122,0.18)'
      }} data-id="element-32">
          {/* Top-left directional highlight */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(135deg, rgba(255,245,220,0.18) 0%, transparent 35%)'
        }} data-id="element-33" />
          {/* Bottom-right shadow */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(135deg, transparent 60%, rgba(0,0,0,0.35) 100%)'
        }} data-id="element-34" />
          {/* Vertical gloss */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(110deg, rgba(255,255,255,0.06) 0%, transparent 25%, transparent 75%, rgba(0,0,0,0.18) 100%)'
        }} data-id="element-35" />
        </div>

        {/* Page edges - finer ribbing */}
        <div className="absolute top-[1%] bottom-[1%] -right-[12px] w-[12px]" style={{
        backgroundImage: 'linear-gradient(90deg, #d8cdb4 0%, #f0e7d3 50%, #c9bd9f 100%),' + 'repeating-linear-gradient(0deg, rgba(120,100,70,0.15) 0px, rgba(120,100,70,0.15) 1px, transparent 1px, transparent 3px)',
        backgroundBlendMode: 'multiply',
        transform: 'rotateY(60deg)',
        transformOrigin: 'left center',
        borderRadius: '1px',
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.25)'
      }} data-id="element-36" />
        {/* Top edge */}
        <div className="absolute -top-[7px] left-[1%] right-[1%] h-[7px]" style={{
        background: 'linear-gradient(180deg, #f0e7d3 0%, #c9bd9f 100%),' + 'repeating-linear-gradient(90deg, rgba(120,100,70,0.1) 0px, rgba(120,100,70,0.1) 1px, transparent 1px, transparent 4px)',
        backgroundBlendMode: 'multiply',
        transform: 'rotateX(60deg)',
        transformOrigin: 'center bottom'
      }} data-id="element-37" />
        {/* Spine shadow */}
        <div className="absolute left-0 top-0 bottom-0 w-[16px] pointer-events-none" style={{
        background: 'linear-gradient(90deg, rgba(0,0,0,0.55), transparent)'
      }} data-id="element-38" />
      </motion.div>

      {/* Floor reflection - softer & elongated */}
      <div className="absolute left-1/2 -translate-x-1/2 -bottom-12 w-[85%] h-[60px] rounded-[50%] blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 40%, transparent 75%)'
    }} data-id="element-39" />
      <div className="absolute left-1/2 -translate-x-1/2 -bottom-6 w-[60%] h-[20px] rounded-[50%] blur-xl pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(212,175,122,0.4), transparent 70%)'
    }} data-id="element-40" />
    </div>;
};